import * as React from "react";
import { LayoutComponent } from "../LayoutComponent";
import { Item, TabList, TabPanels, Tabs, View } from "@adobe/react-spectrum";
import { LayoutDefinition } from "../../../../infra/protected/Layout/LayoutDefinitions";
import { ComponentFactory } from "../ComponentFactory";
import { FPAData } from "../../../../infra/protected/FPA/FPAData";

export interface ITabsLayoutProps {
    selectedItem?: FPAData;
    children?: LayoutDefinition[];
}

function TabsLayout({ selectedItem, children }: ITabsLayoutProps) {
    if(!children) return (<>No children</>);
    return (
        <View>
            <Tabs aria-label="Tabs Layout" isEmphasized>
                <TabList>
                    {children.map((child, index) => (<Item key={`item_${index}`}>{child.name}</Item>))}
                </TabList>
                <TabPanels>
                    {children.map((child, index) => (<Item key={`item_${index}`}>
                        <ComponentFactory selectedItem={selectedItem!} definition={child} systemAttributes={{}} />
                    </Item>))}
                </TabPanels>
            </Tabs>
        </View>
    );
}

export const TabsLayoutComponent = LayoutComponent<ITabsLayoutProps>(TabsLayout);
